<!-- 资源-选择课件/视频/音频/电子书-吴影茹 -->
<template>
  <div>
    <div class="row_between">
      <!-- 标题 -->
      <div class="resource_select_title">
        {{
          '选择' +
            dataList.find((item) => {
              return item.value == type
            })?.label || '课件'
        }}
      </div>
      <!-- 关闭按钮 -->
      <close-outlined v-if="showClose" style="cursor: pointer" @click="closeHandler" />
    </div>
    <!-- 搜索 -->
    <div class="row_between courseware_select_box">
      <!-- 章节信息选择-除电子书类型外 -->
      <ChapterSelect
        v-if="type != 'ebook'"
        placeholder="请选择章节信息"
        width="260px"
        @select="textbookSelectHandler"
        :data="defaultTextbookData"
        v-model:reset="resetValue"
      />
      <!-- 电子书类型选择-仅电子书类型 -->
      <a-select v-model:value="ebookType" :options="ebookTypeList" style="width: 260px" placeholder="请选择电子书类型" v-else></a-select>
      <div class="row_center">
        <a-button @click="reset" class="button_margin_right">重置</a-button>
        <a-button @click="getList(true)" type="primary">搜索</a-button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="courseware_select_list" v-if="dataSource.length != 0">
      <div class="courseware_select_item" :class="type == 'video' ? '' : 'row_stretch'" v-for="(item, index) in dataSource" :key="index">
        <!-- 封面 -->
        <img
          :src="type == 'audio' ? AudioCover : item.cover"
          :class="type == 'video' ? 'video_select_item_cover' : type == 'courseware' ? 'courseware_select_item_cover' : 'audio_select_item_cover'"
        />
        <div :class="type == 'video' ? '' : 'column_start_between'" :style="{ padding: type == 'video' ? '' : '5px 0 10px 0' }" style="width: 100%">
          <div style="width: 100%">
            <!-- 标题 -->
            <div class="courseware_select_item_title">{{ item.title }}</div>
            <!-- 电子书类型 -->
            <div class="courseware_select_item_label" v-if="type == 'ebook'" style="margin-bottom: 20px">
              {{
                '书籍类型：' +
                  ebookTypeList.find((i) => {
                    return i.value == item.ebookType
                  })?.label || '-'
              }}
            </div>
            <!-- 章节信息 -->
            <div class="courseware_select_item_label" style="margin-bottom: 15px; line-height: 20px" v-else>{{ item.textbookGroupName }}</div>
          </div>
          <div :class="type == 'video' ? 'row_between' : ''" style="width: 100%">
            <!--创建人+ 创建时间 -->
            <div class="courseware_select_item_label">{{ item.createBy + '&nbsp;&nbsp;&nbsp;&nbsp;' + item.createTime }}</div>
            <!-- 按钮 -->
            <div :class="type == 'video' ? 'row_center' : 'row_center_end'" :style="{ marginTop: type == 'video' ? '' : '15px' }">
              <a-button @click="detailHandler(item)" class="button_margin_right">预览</a-button>
              <a-button type="primary" :disabled="isSelected(item) || disabled" @click="selectHandler(item)">{{
                disabled ? disabledText : isSelected(item) ? '已添加' : '添加'
              }}</a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 空状态 -->
    <div v-else>
      <OyEmpty style="margin: 30px 0 70px 0" />
    </div>
    <!-- 分页 -->
    <div class="row_center_end">
      <a-pagination
        v-model:current="pageNum"
        v-model:pageSize="pageSize"
        :total="total"
        show-less-items
        :show-total="() => `共 ${total} 条`"
        @change="pageChange"
      />
    </div>
    <!-- 预览课件 -->
    <CoursewareDetail v-if="previewVisible && type == 'courseware'" v-model:visible="previewVisible" :id="previewId" type="previewDetail" />
    <!-- 预览视频 -->
    <VideoDetail v-if="previewVisible && type == 'video'" v-model:visible="previewVisible" :id="previewId" type="previewDetail" />
    <!-- 预览电子书 -->
    <EbookDetail v-if="previewVisible && type == 'ebook'" v-model:visible="previewVisible" :id="previewId" type="previewDetail" />
    <!-- 预览音频 -->
    <AudioDetail v-if="previewVisible && type == 'audio'" v-model:visible="previewVisible" :id="previewId" type="previewDetail" />
  </div>
</template>
            
<script setup lang="ts">
import { onMounted, ref, getCurrentInstance, nextTick, watch } from 'vue'
import { CoursewareInfo } from './types'
import * as api from './service'
import { useRouter } from 'vue-router'
const router = useRouter()
import { useDict } from '@/composable/useDict'
const { getDictData } = useDict()
import AudioCover from '@/assets/images/resource/audio_cover.png'
import CoursewareDetail from '../../views/Resource/Courseware/ModalDetail.vue'
import VideoDetail from '../../views/Resource/Video/ModalDetail.vue'
import EbookDetail from '../../views/Resource/Ebook/ModalDetail.vue'
import AudioDetail from '../../views/Resource/Audio/ModalDetail.vue'
import { CloseOutlined } from '@ant-design/icons-vue'

const props = defineProps({
  // 资源类型 video视频 courseware课件 audio音频 ebook电子书
  type: {
    type: String,
    default: 'courseware'
  },
  // 已选数据数据
  list: {
    type: Array as () => Array<any>,
    default: () => []
  },
  //   需要传入的章节信息参数
  defaultTextbookData: {
    type: Object,
    default: () => {}
  },
  // 是否可选择添加
  disabled: {
    type: Boolean,
    default: false
  },
  // 不可选时的提示文字
  disabledText: {
    type: String,
    default: '不可选择'
  },
  // 单个资源是否仅可选择一次
  isOnly: {
    type: Boolean,
    default: true
  },
  // 是否显示关闭按钮
  showClose: {
    type: Boolean,
    default: false
  }
})

onMounted(() => {
  if (props.type == 'ebook') getDictList()
  getList(true)
})
const emit = defineEmits(['update:list', 'select', 'close'])

const dataList = ref<any>([
  { value: 'video', label: '视频', method: api.videoList },
  { value: 'courseware', label: '课件', method: api.coursewareList },
  { value: 'audio', label: '音频', method: api.videoList },
  { value: 'ebook', label: '电子书', method: api.ebookList }
])

// 列表数据
const dataSource = ref<CoursewareInfo[]>([])

// 章节信息选择
const textbookData = ref<any>({})
// 电子书类型
const ebookType = ref(null)

// 获取课件列表数据
// init 是否需要清空列表数据再拉取数据
const getList = (init = false) => {
  if (init) {
    dataSource.value = []
    pageNum.value = 1
    total.value = 0
  }

  for (const key in textbookData.value) {
    if (textbookData.value[key] === '' || textbookData.value[key] === null) {
      delete textbookData.value[key]
    }
  }

  var method =
    dataList.value.find((item) => {
      return item.value == props.type
    })?.method || api.coursewareList
  var formData: any = {
    params: { status: 1 },
    pageNum: pageNum.value,
    pageSize: pageSize.value
  }
  if (props.type != 'ebook' && textbookData.value && Object.keys(textbookData.value).length != 0) formData.params.textbook = textbookData.value
  if (props.type == 'ebook' && ebookType.value) formData.params.ebookType = ebookType.value
  if (props.type == 'audio') formData.params.type = 'audio'

  method(formData).then((res) => {
    dataSource.value = res.data.list.map((item) => {
      return {
        ...item,
        id: props.type == 'ebook' ? item.ebookId : item.id
      }
    })
    total.value = res.data.total
  })
}

// 分页配置
const pageNum = ref<Number>(1)
const pageSize = ref<Number>(5)
const total = ref<Number>(0)
const pageChange = (page: Number) => {
  pageNum.value = page
  getList()
}

// 选择章节信息
const textbookSelectHandler = (e) => {
  if (e[0]) textbookData.value.studyPeriod = e[0]
  if (e[1]) textbookData.value.gradeCode = e[1]
  if (e[2]) textbookData.value.subjectCode = e[2]
  if (e[3]) textbookData.value.volumeCode = e[3]
  if (e[4]) textbookData.value.versionId = e[4]
  if (e[6]) textbookData.value.parentChapterId = e[6]
  if (e[7]) textbookData.value.chapterId = e[7] || ''
}

// 电子书分类列表
const ebookTypeList = ref<any[]>([])
// 获取状态列表
const getDictList = async () => {
  ebookTypeList.value = await getDictData('ebook_type')
}

// 已选课件列表
const selectedList = ref<any>([])
// 是否已选
const isSelected = (item: any) => {
  return props.isOnly && selectedList.value.some((i) => i.id === item.id)
}

// 预览
const previewVisible = ref(false)
const previewId = ref<string>('')
const detailHandler = (item: any) => {
  previewVisible.value = true
  previewId.value = item.id
}

// 选择
const selectHandler = (item: any) => {
  var index = selectedList.value.findIndex((i) => {
    return i.id == item.id
  })
  if (index == -1) {
    selectedList.value.push({ ...item })
  } else {
    selectedList.value.splice(index, 1)
  }

  emit('update:list', selectedList.value)
  emit('select', item)
}

// 重置
const resetValue = ref(false)
const reset = () => {
  resetValue.value = true
  textbookData.value = {}
  ebookType.value = null
  getList(true)
}

watch(
  () => props.list,
  (newVal) => {
    if (newVal) {
      selectedList.value = newVal.map((item) => {
        return { ...item }
      })
    }
  },
  { immediate: true, deep: true }
)

watch(
  () => props.defaultTextbookData,
  (newVal) => {
    if (newVal && Object.keys(newVal).length != 0) {
      if (newVal[0]) textbookData.value.studyPeriod = newVal[0]
      if (newVal[1]) textbookData.value.gradeCode = newVal[1]
      if (newVal[2]) textbookData.value.subjectCode = newVal[2]
      if (newVal[3]) textbookData.value.volumeCode = newVal[3]
      if (newVal[4]) textbookData.value.versionId = newVal[4]
      if (newVal[6]) textbookData.value.parentChapterId = newVal[6]
      if (newVal[7]) textbookData.value.chapterId = newVal[7]
      getList(true)
    }
  },
  { immediate: true, deep: true }
)

const closeHandler = () => {
  emit('close')
}
</script>
            
<style lang="scss" scoped>
.courseware_select_box {
  margin-top: 20px;
  gap: 15px;
}
.courseware_select_list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin: 20px 0;
}
.courseware_select_item {
  border-radius: 15px;
  padding: 20px;
  border: 1px solid #e5e7eb;
}
.video_select_item_cover {
  width: 100%;
  aspect-ratio: 5/2.8;
  margin-bottom: 20px;
  border-radius: 15px;
}
.courseware_select_item_cover {
  width: 150px;
  aspect-ratio: 3.2/5;
  margin-right: 20px;
  border-radius: 15px;
}
.audio_select_item_cover {
  width: 150px;
  aspect-ratio: 3.5/5;
  margin-right: 20px;
  border-radius: 15px;
}
.courseware_select_item_title {
  font-size: 18px;
  font-weight: bold;
  color: #111827;
  margin-bottom: 10px;
}
.courseware_select_item_label {
  font-size: 14px;
  color: #6b7280;
}
</style>